module.exports = [
  ["\u{1F44D}", "Thumbs up"], ["\u{1F44E}", "Thumbs down"], ["\u{2764}\u{FE0F}", "Heart"],
  ["\u{1F602}", "Laugh"], ["\u{1F60A}", "Smile"], ["\u{1F603}", "Happy"],
  ["\u{1F389}", "Celebrate"], ["\u{1F525}", "Fire"], ["\u{1F44F}", "Clap"],
  ["\u{1F64F}", "Thank you"], ["\u{1F914}", "Thinking"], ["\u{1F440}", "Eyes"],
  ["\u{1F622}", "Sad"], ["\u{1F62E}", "Surprised"], ["\u{1F60D}", "Love"],
  ["\u{1F60E}", "Cool"], ["\u{1F4AF}", "Hundred"], ["\u{2705}", "Check"],
  ["\u{1F680}", "Rocket"], ["\u{1F4A1}", "Idea"], ["\u{1F64C}", "Raised hands"],
  ["\u{1F91D}", "Handshake"], ["\u{1F44B}", "Wave"], ["\u{1F605}", "Relieved"],
];
